import { Component, Input, OnInit } from '@angular/core';
import { Station } from '../../../truck-group.model';

@Component({
    selector: 'app-truck-group-condition-station',
    templateUrl: './truck-group-condition-station.component.html',
    styleUrls: ['./truck-group-condition-station.component.scss'],
    standalone: false
})
export class TruckGroupConditionStationComponent implements OnInit {


  @Input() station: Station;

  @Input() selectedStations: Set<Station>;

  constructor() { }

  ngOnInit() {
  }
}
